export default __webpack_public_path__ + "static/media/area-8.1015922e.jpg";